import "../../../css/components/reusable/modals/InvoiceForm.css";

const InvoiceForm = ({ invoice, handleChange, isIGST, isGST }) => {
    return (
        <div className="invoice-edit-form">
            <h2 className="invoice-edit-title">Invoice Details</h2>

            <div className="invoice-edit-row">
                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Seller Name</label>
                    <input
                        className="invoice-edit-input"
                        value={invoice?.seller_name || ""}
                        onChange={(e) => handleChange("seller_name", e.target.value) }
                    />
                </div>

                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Seller GSTIN</label>
                    <input
                        className="invoice-edit-input"
                        value={invoice?.seller_gstin || ""}
                        onChange={(e) => handleChange("seller_gstin", e.target.value) }
                    />
                </div>
            </div>

            <div className="invoice-edit-row">
                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Buyer Name</label>
                    <input
                        className="invoice-edit-input"
                        value={invoice?.buyer_name || ""}
                        onChange={(e) => handleChange("buyer_name", e.target.value) }
                    />
                </div>

                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Buyer GSTIN</label>
                    <input
                        className="invoice-edit-input"
                        value={invoice?.buyer_gstin || ""}
                        onChange={(e) => handleChange("buyer_gstin", e.target.value) }
                    />
                </div>
            </div>

            <div className="invoice-edit-row">
                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Invoice Number</label>
                    <input
                        className="invoice-edit-input"
                        value={invoice?.invoice_number || ""}
                        onChange={(e) => handleChange("invoice_number", e.target.value) }
                    />
                </div>

                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Invoice Date</label>
                    <input
                        className="invoice-edit-input"
                        type="date"
                        value={invoice?.invoice_date || ""}
                        onChange={(e) => handleChange("invoice_date", e.target.value) }
                    />
                </div>
            </div>

            <div className="invoice-edit-row">
                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Place of Supply</label>
                    <input
                        className="invoice-edit-input"
                        value={invoice?.place_of_supply || ""}
                        onChange={(e) => handleChange("place_of_supply", e.target.value) }
                    />
                </div>

                <div className="invoice-edit-group">
                    <label className="invoice-edit-label">Tax Type</label>
                    <select
                        className="invoice-edit-select"
                        value = { invoice?.tax_type || ""}
                        onChange = { (e) => handleChange("tax_type", e.target.value) }
                    >
                        <option value="">Select Tax Type</option>
                        <option value="IGST">IGST</option>
                        <option value="CGST_SGST">CGST + SGST</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default InvoiceForm;
